import React from 'react';
import { IDeleteAgentDialog } from './interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

export const DeleteAgentDialog: React.FC<IDeleteAgentDialog> = ({
  show,
  agentName,
  disabled = false,
  onClose,
  onConfirm,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={show}>
      <DialogTitle fontWeight="bold">
        {t('agents:prompts.deleteAgent.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans
            i18nKey="agents:prompts.deleteAgent.body"
            components={{ strong: <strong /> }}
            values={{ agentName }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" disabled={disabled}>
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={disabled}
        >
          {t('buttons.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
